import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
const pageData: Record<string, {
  title: string;
  body: string;
}> = {
  '1': {
    title: 'Privacy Statement',
    body: `By registering with Desert Sage Seminars, you will create an account by which we may provide you with quality on-line real estate license renewal classes. Your information will be kept confidential and not shared with any other party.\nThe Arizona Department of Real Estate requires that we confirm your information and that you are the person taking the classes.\nPayments you make for our classes are made through a 3rd party merchant account secured by our site, and they do not share your credit card information with us or any other party.\nAny requests by an outside party for information about you or your account will be denied except for any request from the Arizona Department of Real Estate, or any other regulatory agency empowered to investigate your real estate activity.\nAny questions or concerns about our Privacy Policy should be sent to support@desertsageseminars.com`
  },
  '2': {
    title: 'About Us',
    body: 'Learn about our history and mission.'
  },
  '3': {
    title: 'Terms of Service',
    body: 'Please read these terms carefully.'
  }
};
export function EditStaticPage() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const data = id ? pageData[id] : null;
  return <div className="space-y-4" data-id="element-903" data-mp="1n7xb2m4okrbq">
      <div className="flex items-center justify-between" data-id="element-904" data-mp="1n871ubxjv2ih">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-905" data-mp="1n9rzwbj2p3l3">Edit Static Page</h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/static-pages')} data-id="element-906" data-mp="1ifw4ngu71utm">
          ← Back to Static Pages
        </Button>
      </div>

      <Card data-id="element-907" data-mp="2puj2h7tu5ke3">
        <CardContent className="pt-6" data-id="element-908" data-mp="2psyfq4drj5qs">
          <form className="space-y-5 max-w-2xl" data-id="element-909" data-mp="2ut3z6x9vplxs">
            <Input label="Title" defaultValue={data?.title ?? ''} data-id="element-910" data-mp="2ursvexgfoe6o" />

            <div data-id="element-911" data-mp="2zlx3jk1fqs9c">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-912" data-mp="2zldwwzh8jqam">
                Body
              </label>
              <div className="border border-slate-300 rounded-md overflow-hidden" data-id="element-913" data-mp="34li8cb3adutz">
                {/* Toolbar row 1 */}
                <div className="flex items-center gap-0.5 px-2 py-1 bg-slate-100 border-b border-slate-300 flex-wrap" data-id="element-914" data-mp="2buhy3ied3utv">
                  <button type="button" className="px-1.5 py-0.5 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-915" data-mp="2gt1lzocingov">
                    Source
                  </button>
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-916" data-mp="5gz85mm4jgp" />
                  {['📄', '📋', '✂', '🗑', '↩', '↪'].map((ic, i) => <button key={i} type="button" className="px-1 py-0.5 text-xs border border-transparent hover:border-slate-300 hover:bg-white rounded text-slate-500" data-id="element-917" data-mp="1kmggk3y83btx" data-mpi={i}>
                      {ic}
                    </button>)}
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-918" data-mp="16vuwwd0y2xuz" />
                  {['🔍', '🔤', '🖊'].map((ic, i) => <button key={i} type="button" className="px-1 py-0.5 text-xs border border-transparent hover:border-slate-300 hover:bg-white rounded text-slate-500" data-id="element-919" data-mp="wxx73l3fst09" data-mpi={i}>
                      {ic}
                    </button>)}
                </div>
                {/* Toolbar row 2 */}
                <div className="flex items-center gap-0.5 px-2 py-1 bg-slate-100 border-b border-slate-300 flex-wrap" data-id="element-920" data-mp="2n80fejnq9diw">
                  {['B', 'I', 'U', 'S'].map(t => <button key={t} type="button" className="w-6 h-6 text-xs font-bold border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-700" data-id="element-921" data-mp="1f15nse6ni5ad">
                      {t}
                    </button>)}
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-922" data-mp="1b0ls7f1q79qc" />
                  {['≡', '≣', '❝', '»'].map((t, i) => <button key={i} type="button" className="w-6 h-6 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-923" data-mp="1114nazuaszvf" data-mpi={i}>
                      {t}
                    </button>)}
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-924" data-mp="daqtb3s5kqy7" />
                  <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-925" data-mp="ia3pwg8ttcdz">
                    <option data-id="element-926" data-mp="3utpn5ycjxdt4">Styles</option>
                  </select>
                  <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-927" data-mp="3uty1luobor6f">
                    <option data-id="element-928" data-mp="3pwfpjvf0dvu7">Format</option>
                  </select>
                  <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-929" data-mp="8niz3i98qpn9">
                    <option data-id="element-930" data-mp="3n4y2k624fyq">Font</option>
                  </select>
                  <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-931" data-mp="hn60w55vtxgu">
                    <option data-id="element-932" data-mp="co2uohe61l7a">Size</option>
                  </select>
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-933" data-mp="cnt5gw0y3i2n" />
                  {['A', 'A', '⊞', '⊟', '⊕', '?'].map((t, i) => <button key={i} type="button" className="w-6 h-6 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-934" data-mp="mdw9rsdioiga" data-mpi={i}>
                      {t}
                    </button>)}
                </div>
                <textarea className="w-full p-3 text-sm focus:outline-none resize-y min-h-[200px] bg-white" defaultValue={data?.body ?? ''} data-id="element-935" data-mp="13gbeqox7pb0z" />
              </div>
            </div>

            <div className="pt-2" data-id="element-936" data-mp="1dc51t28k4mx0">
              <Button type="submit" data-id="element-937" data-mp="1i3wjen9qjib0">Submit</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>;
}